"use client";

import {
	QueryClient,
	QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query";
import { ReactElement, ReactNode } from "react";

interface ProviderProps {
	children: ReactNode;
}

function makeQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {},
	});
}

let browserQueryClient: QueryClient | undefined;

function getQueryClient(): QueryClient {
	if (typeof window === "undefined") {
		return makeQueryClient();
	}

	if (!browserQueryClient) browserQueryClient = makeQueryClient();
	return browserQueryClient;
}

export function QueryClientProvider({ children }: ProviderProps): ReactElement {
	const queryClient = getQueryClient();

	return (
		<TanstackQueryClientProvider client={queryClient}>
			{children}
		</TanstackQueryClientProvider>
	);
}
